import React from 'react';
import { SvgIcon, makeStyles } from '@material-ui/core';
import './CustomNextSteps.scss';

const useStyles = makeStyles(theme => ({
    lightBackground: {
        backgroundColor: `${theme.palette.primary.main}16`,
    },
}));

export const CustomNextSteps = (props) => {
    const classes = useStyles();
    return (
        <div className="custom-steps-div">
            <h6 className="text-center mt-2"><b>{props.title}</b></h6>
            {props.data.map((item, key) => (
                <div key={key} className='custom-step-list'>
                    <div className='d-flex'>
                        <div className={`icon-container ${classes.lightBackground}`}>
                            <SvgIcon component={item.icon} color='primary' />
                        </div>
                        <div className='main-subtitle mt-1' dangerouslySetInnerHTML={{ __html: item.text }} />
                    </div>
                    {item.subText &&
                        <ul>
                            {item.subText.map((i, k) => (
                                <li><div key={k} className='subtext' dangerouslySetInnerHTML={{ __html: i }} /></li>
                            ))}
                        </ul>
                    }
                    {item.subTitle &&
                        <div className='subtitle' dangerouslySetInnerHTML={{ __html: item.subTitle }} />
                    }
                </div>
            ))}
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/Appointment/CustomNextSteps.js